import $ from "jquery";
export function eventform() {
    var eventID = $("#event_id").val();
    if (eventID == "") {
      $("#wpforms-267-field_17 [value='" + eventID + "']").prop("selected", true);
    }
}
